<template>
  <b-card class="custom-card">
    <div :id="downloadId" class="container-line-chart bg-dark-blue">
      <div class="watermark disp-none"></div>
      <b-card-header>
        <div class="card-text-strong">
          <span class="card-management-title" style="color: #ffffff; prefers-color-scheme: light">{{ titleChart }} </span>
          <i
            class="fa fa-info-circle help-icon remove-elem-download"
            style="color: #d9d9d9"
            v-if="titleTooltip != ''"
            v-b-tooltip.hover="{
              placement: 'rightbottom',
              title: titleTooltip,
              html: tooltipHtmlContent
            }"
          />
          <slot name="header"></slot>
        </div>
        <slot name="subheader"></slot>
      </b-card-header>
      <b-card-body class="transparent">
        <div style="width: 100%;">
          <slot name="body" style="width: 100%;"></slot>
        </div>
      </b-card-body>
      <div>
        <div class="d-none mt-26 download-info">
          <div class="d-flex justify-content-between">
            <div :class="`info-text ml-12 ${isZoomEnabled && zoomGraphValueChild ? 'zoom' : ''}`">
              This visualization is powered by one or more of THREAD’s proprietary algorithms, which, as trade secrets, are
              <br />afforded robust legal protections and may not be used in any manner without the prior written consent of THREAD.
            </div>
            <div class="ml-20 d-flex logo-flex-end mb-3">
              <img src="@/assets/white-thread_logo_tm.png" :class="`${isZoomEnabled && zoomGraphValueChild ? 'mr-15 mt-8 pr-15' : 'mr-15 mt-8 pr-15'}`" :height="`${isZoomEnabled && zoomGraphValueChild ? '24' : '24'}`" />
            </div>
          </div>
        </div>

        <div class="text-right">
          <span class="remove-elem-download">
            <img v-if="downloadShow" src="@/assets/white-thread_logo_tm.png" class="pr-11 pb-11" height="35" />
            <span class="pr-10" v-if="downloadShow">
              <img src="static/img/download-graphs.png" class="download_graph cursor_pointer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Download" />
              <div class="dropdown-menu download-dropdown-box p-0">
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadCSVGraphs()"><img src="/static/img/csv.svg" class="mr-6" />CSV</span>
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadPDFGraphs()"><img src="/static/img/pdf.svg" class="mr-6" />PDF</span>
                <span class="dropdown-item download-dropdown-item border-bottom cursor_pointer" @click="downloadPNGGraphs()"><img src="/static/img/img.svg" class="mr-6" />PNG</span>
              </div>
            </span>

            <span @click="zoomGraph(true)" class="cursor_pointer pr-20" title="Expand" v-if="isZoomEnabled && !zoomGraphValueChild && downloadShow">
              <img src="/static/img/expandbox.svg" class="download_graph" />
            </span>
            <span @click="zoomGraph(false)" class="cursor_pointer pr-20" v-if="isZoomEnabled && zoomGraphValueChild && downloadShow" title="Collapse">
              <img src="/static/img/unexpand.svg" class="download_graph" />
            </span>
          </span>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import jspdf from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import { getSiteID } from "../../services/visualization/data-management";

export default {
  props: {
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    containerId: { type: String },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    specificSiteId: [Object, Array],
    onCSVDownload: { type: Function, default: null },
    onPNGDownload: { type: Function, default: null },
    onPDFDownload: { type: Function, default: null },
    isZoomEnabled: { type: Boolean, default: true },
    downloadShow: { type: Boolean, default: false },
    titleTooltip: { type: String, default: "" },
    tooltipHtmlContent: { type: Boolean, default: false },
    tooltipPlacement: { type: String, default: "rightbottom" },
    showThreadLogoInUnexpand: { type: Boolean, default: false }
  },
  data() {
    return {
      type: "line",
      dataFormat: "json",
      renderAt: "chart-container",
      width: "100%",
      height: "250",
      zoomGraphValueChild: "",
      getSiteID
    };
  },

  watch: {
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    }
  },
  methods: {
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    downloadPNGGraphs() {
      if (this.onPNGDownload) {
        this.$emit("onPNGDownload");
        return;
      }
      this.download("png");
    },
    downloadPDFGraphs() {
      if (this.onPDFDownload) {
        this.$emit("onPDFDownload");
        return;
      }

      this.download("pdf");
    },
    download(type) {
      const todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      const container = document.querySelector("#" + this.downloadId);
      let filename = this.titleChart + "_" + todayDate + "." + type;
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        filename = this.titleChart + "_" + todayDate + "_" + getSiteID(this.specificSiteId[0]) + "." + type;
      }
      html2canvas(container, {
        allowTaint: true,
        logging: false,
        height: !this.zoomGraphValueChild ? 400 : 650,
        scrollY: -window.scrollY,
        useCORS: true,
        scrollX: -window.scrollX,
        onclone: document => {
          document.querySelectorAll(".bg-gradient-blue").forEach(el => el.classList.add("download"));
          document.querySelectorAll(".download-info").forEach(el => el.classList.remove("d-none"));
          document.querySelector("#" + this.downloadId + " .watermark").classList.remove("disp-none");
          if (this.specificSiteId && this.specificSiteId.length > 0) {
            if (document.querySelector("#" + this.downloadId + " .title-date") != null) {
              document.querySelector("#" + this.downloadId + " .title-date").append("_" + this.getSiteID(this.specificSiteId[0]));
            } else {
              document.querySelector("#" + this.downloadId + " .card-management-title").append("_" + this.getSiteID(this.specificSiteId[0]));
            }
          }
          document.querySelectorAll("#" + this.downloadId + " .custom-tooltip").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .apexcharts-toolbar").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-elem-download").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .remove-zoom-icons").forEach(element => {
            element.remove();
          });
          document.querySelectorAll("#" + this.downloadId + " .nav-item").forEach(element => {
            const ele = element.querySelector(".nav-link.active");
            if (!ele) {
              element.remove();
            }
          });
          const dateTime = document.createElement("div");
          dateTime.classList.add("ml-12", "mt-10", "fs-18");
          dateTime.textContent = todayDate;
          dateTime.style.color = "#b0bac9";
          document.querySelector("#" + this.downloadId).append(dateTime);
          if (document.querySelectorAll(".table-content").length > 0) {
            document.querySelectorAll(".table-content")[0].className = "remove-overflow";
          }
          if (document.querySelectorAll(".rtl-display").length > 0) {
            document.querySelectorAll(".rtl-display")[0].className = "ltr-display";
          }
        }
      }).then(canvas => {
        if (type === "pdf") {
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jspdf("p", "mm", "a4");
          const imgProps = pdf.getImageProperties(imgData);
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth - 0, pdfHeight);
          pdf.save(filename);
        } else if (type === "png") {
          const link = document.createElement("a");
          document.body.appendChild(link);
          link.download = filename;
          link.href = canvas.toDataURL("image/png");
          link.target = "_blank";
          link.click();
        }
      });
    },
    downloadCSVGraphs() {
      this.$emit("onCSVDownload");
    }
  }
};
</script>
<style lang="scss" scoped>
#app,
.container-line-chart {
  width: 100%;
  border-radius: 5px;

  padding-bottom: 40px;
}
.bg-dark-blue {
  background-color: #243e64;
}

.info-text {
  font-size: 12px;
  max-width: 628px;
  color: #b0bac9;
}
.font-size-18 {
  font-size: 18px;
}
.logo-flex-end {
  align-items: flex-end;
}
.custom-card {
  border: 0px;
  min-height: 299px;
}
.watermark {
  content: "";
  background-image: url(/static/img/thread-white-tm.png);
  background-size: 250px;
  display: block;
  background-repeat: space;
  width: 500%;
  height: 500%;
  position: absolute;
  top: -380%;
  left: -88%;
  display: block;
  transform: rotate(-30deg);
  opacity: 0.1;
}

.disp-none {
  display: none;
}

.transparent {
  background-color: transparent;
}
.container-line-chart {
  width: 100%;
}

.bg-gradient-blue {
  .help-icon {
    color: #d9d9d9;
  }

  .bg-dark-blue {
    background: linear-gradient(180deg, #657892 0%, #253f65 100%) !important;
  }

  &.download {
    .bg-dark-blue {
      background: #243e64 !important;
    }
  }
}
</style>
